<template>
  <v-card class="skeleton-chart elevation-1">
    <v-card-title class="pa-2">
      <div class="skeleton-chart-title skeleton-shimmer"></div>
    </v-card-title>
    <v-card-text class="pa-3">
      <div class="skeleton-chart-body">
        <div v-for="n in barCount" :key="n" class="skeleton-bar-wrapper">
          <div
            class="skeleton-bar skeleton-shimmer"
            :style="{ width: getRandomWidth(n) }"
          ></div>
        </div>
      </div>
      <div v-if="showLegend" class="skeleton-legend mt-3">
        <div v-for="n in 4" :key="'legend-' + n" class="skeleton-legend-item skeleton-shimmer"></div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SkeletonChart',
  props: {
    barCount: {
      type: Number,
      default: 6
    },
    showLegend: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getRandomWidth (index) {
      const widths = ['50%', '70%', '85%', '65%', '90%', '75%', '60%', '80%']
      return widths[index % widths.length]
    }
  }
}
</script>

<style scoped>
.skeleton-chart {
  background-color: #ffffff;
  min-height: 350px;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-chart-title {
  height: 20px;
  width: 40%;
}

.skeleton-chart-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 0;
}

.skeleton-bar-wrapper {
  display: flex;
  align-items: center;
}

.skeleton-bar {
  height: 28px;
  transition: width 0.3s;
}

.skeleton-legend {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.skeleton-legend-item {
  height: 16px;
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SkeletonChart.vue